import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

// ── Card wrapper for a single entity's form ─────────────────────────────

export const FormCard = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  padding: 20px;
  border: 1px solid ${theme.gainsBoro};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);

  @media ${deviceType.mobile} {
    border: none;
  }
`;

// ── Field layout ────────────────────────────────────────────────────────

export const FieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;

  @media ${deviceType.mobile} {
    flex-direction: column;
    gap: 12px;
  }
`;

export const FieldItem = styled.div`
  flex: 1 1 180px;
  min-width: 0;

  @media ${deviceType.mobile} {
    flex: 1 1 100%;
    width: 100%;
  }
`;

export const DateFieldWrapper = styled.div`
  flex: 0 0 auto;
  width: 200px;

  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const FieldsFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 4px;
`;

// ── Grid layout (used by AddNomineeModal) ───────────────────────────────

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media ${deviceType.mobile} {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

// ── Radio / Gender ──────────────────────────────────────────────────────

export const GenderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;

  @media ${deviceType.mobile} {
    flex-direction: column;
    gap: 12px;
  }
`;

export const RadioFieldWrapper = styled.div`
  flex: 0 0 auto;

  @media ${deviceType.mobile} {
    flex: 1 1 100%;
    width: 100%;
  }
`;

export const GenderSection = styled.div`
  flex: 1;
`;

export interface GenderTypeItemProps {
  selected?: boolean;
}

export const GenderTypeItem = styled.div<GenderTypeItemProps>`
  background: ${theme.whiteText};
  border: 1px solid ${theme.lightGreyText};
  border-radius: 6px;
  padding: 0 12px;
  cursor: pointer;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(p) =>
    p.selected &&
    `
    background: var(--tm-accent-bg-color);
    border: 1px solid ${theme.blueText};
    border-width: 1px;
    border-radius: 6px;
`}
`;

export const ModalRadioButtonStyle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  label {
    user-select: none;
  }
  input {
    display: none;
  }

  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 24px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    color: ${theme.greyText3};
    width: 100%;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
    height: 15px;
    border: 1px solid var(--tm-accent-color);
    border-radius: 100%;
    background: ${theme.whiteText};
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: "";
    width: 9px;
    height: 9px;
    background: var(--tm-accent-color);
    position: absolute;
    top: 50%;
    left: 3px;
    transform: translateY(-50%);
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: translateY(-50%) scale(0);
    transform: translateY(-50%) scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1);
  }
`;

// ── Dynamic fields ──────────────────────────────────────────────────────

export const DynamicFieldTrigger = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
  margin-top: 8px;

  @media ${deviceType.mobile} {
    align-self: flex-start;
  }
`;

export const AddressFieldWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  display: block;
`;

// ── Error banner ────────────────────────────────────────────────────────

export const ErrorBanner = styled.div`
  background: ${theme.lightRed};
  border: 1px solid ${theme.lightRed};
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ErrorIcon = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
